export interface BaseTableColumns {
    id: number;
    date: string;
}

export class TicketingTableColumns implements BaseTableColumns {
    constructor(public id: number, public sender: string, public date: string,public receiver: string, public receiverNumber: string, public message: string) {}
}

